import React from "react";
import { EmptyState } from "@dowty/ui";

/**
 * The "you can't see this album" state, shared by the album, map and stats pages. The wording is
 * deliberately distinct from an empty album: the backend answers NOT_FOUND when a row was deleted,
 * unshared, or never belonged to the caller, and rendering that as "nothing here yet" reads as data loss
 * rather than lost access. Extracted so that sentence lives once — it was three near-identical copies.
 */
export const AlbumNoAccess: React.FC<{ icon: React.ReactNode }> = ({ icon }) =>
    <EmptyState icon={icon} title="You don't have access to this album — it may have been removed or unshared with you." />;
